<!-- 由 suu 创建于 2021-07-08 星期四 -->
<template>
  <div class="other-info">
    <!-- 排行 -->
    <!-- <div class="oi-panel">
      <div class="p-title">食物排行</div>
      <div
        class="rank-item"
        @click="$router.push('/calorie-query/food-rank?id=' + item.rankid)"
        v-for="(item, index) in info.rank"
        :key="index"
      >
        <div class="i-dot"></div>
        <div class="i-text">在「{{ item.title }}」排{{ item.value }}名</div>
        <div class="i-right">></div>
      </div>
    </div> -->
    <!-- 单位重量 -->

    <div class="oi-panel">
      <div class="p-title">单位重量</div>
      <div class="p-tips">
        重量应按照可食用部分来计算。<br />
        例如玉米的可食用部分不包含玉米芯，西瓜的可食用部分不包括西瓜皮。<br />
        番茄的可食用部分约占总重量的97%。
      </div>
      <div class="oi-card">
        <div class="c-item" v-for="(item, index) in info.unit" :key="index">
          <div class="i-left">
            <div class="l-top">{{ item.title }}</div>
            <div class="l-bot">
              {{ item.weight }}克，可食用部分：{{ item.weight_eat }}克
            </div>
          </div>
          <div class="i-right">{{ item.calorie }}千卡</div>
        </div>
      </div>
    </div>
    <!-- 血糖相关 -->
    <div class="oi-panel">
      <div class="p-title">血糖相关</div>
      <div class="oi-card">
        <div
          class="c-item"
          v-for="(item, index) in info.bloodsugar"
          :key="index"
        >
          <div class="i-left">
            <div class="l-top">{{ item.title }}</div>
          </div>
          <div class="i-cent">{{ item.value }}</div>
          <div class="i-right">
            {{ item.mark }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'other-info',

  components: {},

  props: {
    info: {}
  },

  data() {
    return {}
  },

  computed: {},

  watch: {},

  created() {},

  mounted() {},

  destroyed() {},

  methods: {}
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 375) * 100vw;
}
.other-info {
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: left;
  margin-bottom: 16px;
  .oi-panel {
    width: 91.5vw;
    box-sizing: border-box;
    padding: 3.7vw 4.3vw;
    border-radius: 2.7vw;
    margin-top: 4.3vw;
    background-color: #fff;
    .p-title {
      font-size: 4vw;
      font-weight: 600;
      color: #000000;
      margin-bottom: 0.5vw;
    }
    .rank-item {
      width: 100%;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      padding: 2.7vw 0;
      font-size: 3.2vw;
      font-weight: 600;
      color: #3b4761;
      .i-dot {
        width: 2.1vw;
        height: 2.1vw;
        background-color: #3b4761;
        border-radius: 0.8vw;
        opacity: 0.2;
        margin-right: 2.7vw;
      }
      .i-right {
        flex: 1;
        text-align: right;
        font-size: 2.7vw;
        color: #878787;
      }
    }
    .rank-item + .rank-item {
      border-top: dashed 0.3vw #e7e7e7;
    }
    .p-tips {
      font-size: 3.2vw;
      line-height: 5.9vw;
      color: rgba(0, 0, 0, 0.5);
      margin-top: 4.3vw;
      text-align: center;
    }
    .oi-card {
      width: 100%;
      box-sizing: border-box;
      padding: 3.2vw 4.3vw;
      background-color: #f7f7f7;
      border-radius: 2.1vw;
      border: solid 0.3vw #f1f1f1;
      margin-top: 6.4vw;
      .c-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .i-left {
          .l-top {
            font-size: 3.2vw;
            font-weight: 600;
            color: #000;
          }
          .l-bot {
            font-size: 2.7vw;
            color: rgba(0, 0, 0, 0.5);
          }
        }
        .i-cent {
          font-size: 3.2vw;
          font-weight: 600;
          color: #3b4761;
        }
        .i-right {
          font-size: 4vw;
          font-weight: 600;
          color: #3b4761;
        }
      }
      .c-item + .c-item {
        margin-top: 2.9vw;
        padding-top: 2.9vw;
        border-top: dashed 0.3vw #bcbcbc;
      }
    }
  }
}
</style>
